'use strict'; // @ts-ignore is-loopback-addr does not publish types

var isLoopbackAddr = require('is-loopback-addr');
/**
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */

/**
 * Check if a given multiaddr is a loopback address.
 *
 * @param {Multiaddr} ma
 * @returns {boolean}
 */


function isLoopback(ma) {
  var _ma$nodeAddress = ma.nodeAddress(),
      address = _ma$nodeAddress.address;

  return isLoopbackAddr(address);
}

module.exports = isLoopback;